// ===========================================
// Admin Teacher View Context - Types & Context
// ===========================================
// Allows users with multiple roles/access levels to switch between views.
// Supported views:
//   admin   - Full admin dashboard (ADMIN role users)
//   staff   - Staff dashboard (users with a custom staff role)
//   teacher - Teacher dashboard (users who are also teachers)
//   parent  - Parent dashboard (users who are also parents)

import { createContext } from 'react';

// All possible view modes
export type AdminTeacherView = 'admin' | 'staff' | 'teacher' | 'parent';

// State for the active view
export interface AdminTeacherViewState {
  currentView: AdminTeacherView;
}

// Context type with actions
export interface AdminTeacherViewContextType extends AdminTeacherViewState {
  setView: (view: AdminTeacherView) => void;
  toggleView: () => void;
  /** Ordered list of views available to the current user */
  availableViews: AdminTeacherView[];
}

// Create context - exported for useAdminTeacherView hook
export const AdminTeacherViewContext = createContext<AdminTeacherViewContextType | undefined>(undefined);
